import { Currency } from '../../constants/currency.js';
import { getAmountString, getAmountRangeToString } from '../../helpers/humanization.js';

const FREQUENCY_TO_LABEL = {
    month: 'в мес',
    year: 'в год',
    lumpSum: '',
};
const getDebitCardsTerms = item => {
    const conditions = [];
    const { sortCashbackMin, sortCashback, maintenancePrice, maintenancePriceSS, sortBalanceIncome, sortBalanceIncomeMin, frequencyNew, currencyMaintenance, } = item;
    let rateValue;
    if (sortBalanceIncome && sortBalanceIncomeMin) {
        if (sortBalanceIncome !== sortBalanceIncomeMin) {
            rateValue = `${sortBalanceIncome} - ${sortBalanceIncomeMin}`;
        }
        rateValue = sortBalanceIncome;
    }
    else {
        if (sortBalanceIncome) {
            rateValue = sortBalanceIncome;
        }
        if (sortBalanceIncomeMin) {
            rateValue = sortBalanceIncomeMin;
        }
    }
    const cashbackValue = sortCashback && (sortCashbackMin ? `${sortCashbackMin} - ${sortCashback}` : String(sortCashback).replace('.', ','));
    let cost = maintenancePrice ? `${getAmountString(maintenancePrice, Currency.RUB)} в год` : 'бесплатно';
    if (maintenancePriceSS < 0.1) {
        cost = maintenancePriceSS ? `${getAmountString(maintenancePriceSS, Currency.RUB)}` : 'бесплатно';
    }
    else if (Object.keys(FREQUENCY_TO_LABEL).includes(frequencyNew) &&
        [Currency.RUB, Currency.EUR].includes(currencyMaintenance)) {
        cost = `${getAmountRangeToString({
            amountRange: {
                from: maintenancePrice,
                to: maintenancePriceSS,
            },
            allowZero: true,
            currency: currencyMaintenance,
            defaultText: 'бесплатно',
            prefix: true,
        })} ${FREQUENCY_TO_LABEL[frequencyNew]}`;
    }
    rateValue && conditions.push({ value: `${rateValue}%`, description: 'процент на остаток', key: 'rate' });
    if (cashbackValue) {
        conditions.push({ value: `${cashbackValue}%`, description: 'кэшбэк', key: 'cashback' });
    }
    conditions.push({
        value: cost,
        description: 'обслуживание',
        key: 'cost',
    });
    return conditions;
};

export { getDebitCardsTerms };
//# sourceMappingURL=debitCards.js.map
